import React, {Fragment} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import * as api from "../../apis/sysWorkflow";
import useAntTable from "../../utils/useAntTable";
import withAuth from "../../utils/withAuth";
import ServiceModal from "./serviceModal";
import useFormModal from "../../utils/useFormModal";

const EditFragment = withAuth('edit', Fragment)

function SysWorkflow() {

    const {tableProps, refresh} = useAntTable(api.getWorkflows, {})
    const {modalProps: serviceModalProps, setVisible: setServiceVisible} = useFormModal({
        onRequest: api.modifyWorkflow,
        onOk: () => {
            setServiceVisible(false)
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '工作流名称',
            dataIndex: 'name'
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: value => value ? '启用' : '停用',
        },
        {
            title: '消息字体颜色',
            dataIndex: 'color',
            render: value => (<div style={{width: 15, height: 15, background: value}}/>),
        },
        {
            title: '邮件通知',
            dataIndex: 'notify',
            render: value => value ? '启用' : '停用',
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_: any, record: any) => (
                <span>
                    <EditFragment>
                        <a onClick={() => onModify(record)}>编辑</a>
                    </EditFragment>
                </span>
            )
        }
    ]

    function onModify(record: any) {
        if (record.code === 'sale-service') {
            setServiceVisible(true, record)
        }
    }

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} />
            <ServiceModal {...serviceModalProps} />
        </PageHeaderLayout>
    )
}

export default SysWorkflow